import { AuthPermissionGuard } from './auth-permission.guard';
import { AuthGuard } from './auth.guard';
import { MaintenanceGuard } from './maintenance.guard';

export const Guards = [AuthGuard, AuthPermissionGuard, MaintenanceGuard];
